module.exports = __webpack_public_path__ + "img/1484540188.72935706.jpg";